import { matchPath } from "react-router-dom";
import { vendorRouteConfig } from "./VendorRouteConfig";

export const getVendorRouteInfo = (pathname) => {
  for (const route in vendorRouteConfig) {
    const match = matchPath({ path: route, end: true }, pathname);
    if (match) {
      return vendorRouteConfig[route];
    }
  }

  return {
    pageTitle: "",
    breadcrumbs: []
  };
};
